var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polyline, _path9, _path10, _path11, _line, _line2, _line3, _polygon, _line4, _line5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g5, _g6, _g7, _g8, _path20, _path21, _path22, _line6, _line7, _path23, _path24, _path25, _path26, _path27, _path28, _line8, _line9, _line10, _path29, _line11, _circle, _circle2, _line12, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWomanIdea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.84 542.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ilustracion") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "ff61bd5d-3e10-47b4-bae1-01aa688afa1c",
    "data-name": "Capa 2"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a1dc24dd-97c2-4b2c-b054-e2a3b9c5385d",
    "data-name": "SHADOW"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183,526.08c-39.8-.19-36,10.93-1.24,10.93S216.9,526.23,183,526.08Z",
    fill: "#fdd686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.81,492.56c-59.73,0-181.2-1.68-181.2-1.68-46.91,0-86-3.31-100.94,0s-4.52,6.4-4.52,6.4S86.74,494.15,76,500.16s12.48,19.79,62.5,17,79.77-1.08,105.41,15.45,104.5,7.19,121.72,2.14,9.53-15.63-12.88-14.68-5.46-7.18,49.12-2.91S477.53,492.56,417.81,492.56ZM189.28,507.13c-22.06,1.54-30-1.63-15.81-2.79C196.26,502.47,211.35,505.59,189.28,507.13Zm94.44,14.48c-8.62-1.54-4.62-7.08-22-7.36s-26.33-4.34-14-4.8c20.33-.77,33.57,1.07,37.9,3.81s27.7-2.74,28.31,2.27S292.34,523.15,283.72,521.61Z",
    fill: "#fdd686"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "be456e18-6d78-4525-9ed7-4ac55955e936",
    "data-name": "BACKGROUND"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.51,398.53c-12.22,48.4-71.43-8.23-72.37,38.76S286.56,487.11,236.28,481s-28.67-47-67.68-49.81S73.67,441.24,53,383.9,40.78,218.54,42.18,160.26s37.13-26.79,38.07-70c.47-21.48,5.92-38.33,20.16-51.29l.21-.18c2.15-1.83,20.81-17,45.34-14.18,26.09,3,34.17,12.89,37.19,40.14s48.32,25.22,45.4-18,76.54-34.2,100.73-32c17.2,3.31,29.5,8.22,32,15.37,9.87,28.2.47,64.86,21.62,63.92s62.5-2.35,68.14,42.76S463.73,350.12,451.51,398.53Z",
    fill: "#fdd686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,180.46c-25.63,0-31.94,36.21-31.94,82.8s-1.31,110.89,40,134.51,78.74-9.19,51.18-40.68-19.68-77.43-19.68-107S317.85,180.46,278,180.46Z",
    fill: "#fcbf49",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.39,37.37c-30,0-29.54,36.57-29.54,68.45s3.75,62.36,31.88,62.36,31.41-32.82,31.41-62.83S313,37.37,277.39,37.37Z",
    fill: "#fcbf49",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.55,52.91c-19,0-19.08,18.47-19.08,32.69s2.37,27.81,20.18,27.81,19.89-14.64,19.89-28S301.11,52.91,278.55,52.91Z",
    fill: "#fcbf49",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.81,334.38c-23.65,3.78-15,35.44.13,49,15,13.37,37.35,12.2,41.43-.88,2.57-8.23,4.16-19.86-12.32-24.06S305.66,331.52,287.81,334.38Z",
    fill: "#fcbf49",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.64,46.3c-22.58,0-28.85,16.73-28.85,34.29s10,29.68,32.61,29.68S167.09,94,167.09,79.33,157.05,46.3,133.64,46.3Z",
    fill: "#fcbf49",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.52,125.06c-28,0-25.31,47.93-25.31,79.16s-1.08,81.86,35.54,81.86,31.77-41.47,31.77-79.7S172.76,125.06,127.52,125.06Z",
    fill: "#fcbf49",
    opacity: 0.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "a78a9e48-500f-4a95-a224-a1d5744ee9bd",
    "data-name": "LAMP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.71,111.56a91.82,91.82,0,0,1-64.29,68.55,18,18,0,0,0-12.61,13.55l-2.53,11.89-66-14.07,2.53-11.9a18.06,18.06,0,0,0-6-17.55,91.94,91.94,0,0,1-32.55-73.48,93.82,93.82,0,0,1,2-15.84,91.84,91.84,0,1,1,179.52,38.85Z",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.15,195.88,369,173s-15.32-24.5-7.52-59.49,33.42-17.28,25.88,2.4S375.91,90.48,398.9,94.57c18.05,3.22,11,31.56,5.8,30.46s-1-25,13.77-21.9,9.45,51.7-19.4,74.88l-5.57,26.16",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.71,111.56a91.82,91.82,0,0,1-64.29,68.55,18,18,0,0,0-12.61,13.55l-2.53,11.89-66-14.07,2.53-11.9a18.06,18.06,0,0,0-6-17.55,91.94,91.94,0,0,1-32.55-73.48c12.49,22.8,39,48.79,91.9,50.59,61.55,2.09,81-47.37,87-76A91,91,0,0,1,489.71,111.56Z",
    fill: "#b85f00",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.46,
    y: 230.52,
    width: 38.88,
    height: 23.99,
    rx: 11.65,
    transform: "translate(58.64 -71.37) rotate(12.03)",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,208.27,406,246.14a4.84,4.84,0,0,1-5.73,3.72l-44.92-9.58L335.4,236a4.79,4.79,0,0,1-3.71-5.71l8.07-37.89a4.81,4.81,0,0,1,5.72-3.71l37.76,8.05,27.07,5.77A4.82,4.82,0,0,1,414,208.27Z",
    fill: "#0085cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,208.27,406,246.14a4.84,4.84,0,0,1-5.73,3.72l-44.92-9.58c23.31-12.81,27.59-32.32,27.94-43.51l27.07,5.77A4.82,4.82,0,0,1,414,208.27Z",
    fill: "#003049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.44,205.24l80.1.09a3.09,3.09,0,0,0,0-6.18l-80.1-.09a3.09,3.09,0,0,0,0,6.18",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,221.55l82.57.09a3.09,3.09,0,1,0,0-6.18L332,215.37a3.09,3.09,0,0,0,0,6.18",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.85,237.92l79.2,0a3.09,3.09,0,0,0,0-6.18l-79.2,0a3.09,3.09,0,0,0,0,6.18",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.12,27c-9.52-7.52-32.72,16.27-39.59,40.78s-1.36,53.85,11.45,52.75,5.26-22.12,9.65-41.42S384.07,42,365.12,27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.93,9c-15.48,3.39-18.36,24.53,3.55,21.81S416.44,4.32,394.93,9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.64,220.22a5,5,0,0,1-.39,1.1,5.14,5.14,0,0,1-5.78,2.77l-73.63-16.78A3.79,3.79,0,0,1,337,207l-96.55-41.23-5.78-2.47,5.08-9,100.86,43.08,73.18,16.69A5.16,5.16,0,0,1,417.64,220.22Z",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.25,221.32a5.14,5.14,0,0,1-5.78,2.77l-73.63-16.78A3.79,3.79,0,0,1,337,207l-96.55-41.23,7.62-3.52,89.53,40.49Z",
    fill: "#b85f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2,155.18c.54.28,1.06.58,1.59.87a14.71,14.71,0,0,0,1.72.76l1.7.68a6.56,6.56,0,0,0,1.79.62.75.75,0,0,0,.73-.55.79.79,0,0,0-.34-.86,3.65,3.65,0,0,0-.91-.38l-.86-.32-1.65-.61a14.28,14.28,0,0,0-1.68-.54c-.59-.14-1.19-.26-1.78-.41a.41.41,0,0,0-.31.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44,160.38a112.61,112.61,0,0,0,12.06,5.45c4.31,1.61,8.64,3.14,12.93,4.78,8.32,3.16,16.72,6.11,25,9.43,2.3.93,4.54,1.92,6.89,2.71s4.68,1.95,7.12,2.64a.6.6,0,0,0,.46-1.09C325,183,323,182.21,321,181.08a51.64,51.64,0,0,0-5.78-2.85c-4.12-1.76-8.25-3.52-12.44-5.11-8.37-3.18-16.85-6-25.28-9.06-2.38-.85-4.76-1.8-7.2-2.48s-5.1-1.23-7.64-1.8c-.35-.08-.6.42-.25.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.37,184.1c2.09,1,4.12,2.07,6.22,3s4.12,1.72,6.18,2.54c4.27,1.7,8.39,3.68,12.5,5.71,8.36,4.12,16.63,8.41,24.94,12.64,1.78.9,3.34-1.83,1.55-2.67-8.54-4-17.1-7.9-25.59-12-3.94-1.89-7.88-3.75-11.95-5.35-2.13-.83-4.28-1.65-6.44-2.41-2.34-.82-4.77-1.41-7.13-2.16-.39-.12-.66.49-.28.67Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "bed383ee-a8c8-410d-8e94-e1e2cd92ddb3",
    "data-name": "LEFT ARM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.71,209.75s-6.09,44.6-14.34,58.81a11.4,11.4,0,0,1-2.89,3.56,22.56,22.56,0,0,1-24.75,1.07c-5.91-3.34-11.79-9.63-16.75-20.12-12.79-27.15-27.4-79.87-27.4-79.87l3.19-3.53,5.9-6.54s14.76-8.14,18.66,3.18,21.07,55,21.07,55l11.31-25.75a29.64,29.64,0,0,1,10.09,1.78A31.14,31.14,0,0,1,224.71,209.75Z",
    fill: "#d62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.71,209.75s-6.09,44.6-14.34,58.81a11.4,11.4,0,0,1-2.89,3.56,22.56,22.56,0,0,1-24.75,1.07c-5.91-3.34-11.79-9.63-16.75-20.12-12.79-27.15-27.4-79.87-27.4-79.87l3.19-3.53,8.93,12.26s20.86,26.28,24.92,34.55,9.67,29.39,9.67,29.39a79.19,79.19,0,0,1,2.11-24.55,86.24,86.24,0,0,0,10.36,17.07l11-41A31.14,31.14,0,0,1,224.71,209.75Z",
    fill: "#ac2020"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.84,
    cy: 231.28,
    r: 2.94,
    fill: "#1b2d3d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.25,
    cy: 219.42,
    r: 2.94,
    fill: "#1b2d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.71,209.75a34.13,34.13,0,0,1-5.46.17c-11.67-.57-17.11-7.51-19.28-11.52a16.65,16.65,0,0,1-1.26-2.83,15.5,15.5,0,0,1,1.81,0h0a31.84,31.84,0,0,1,19.4,8.44A32.26,32.26,0,0,1,224.71,209.75Z",
    fill: "#680913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.07,225.65a81.11,81.11,0,0,0,.65,27.61",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.44,228.88s1.73,13.16,5.18,20.93",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,268.56a11.4,11.4,0,0,1-2.89,3.56,22.56,22.56,0,0,1-24.75,1.07,18.88,18.88,0,0,1,3.19-6.31,15.11,15.11,0,0,1,8.54-5.48,12.75,12.75,0,0,1,9.88,1.83,23.75,23.75,0,0,1,2.84,2.07A30.32,30.32,0,0,1,210.37,268.56Z",
    fill: "#bb233d"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.23,
    y1: 261.54,
    x2: 203.45,
    y2: 264.96,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.5,
    y1: 263.32,
    x2: 206.05,
    y2: 267,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.29,
    y1: 266.18,
    x2: 188.02,
    y2: 269.19,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.38,176.18c0,1.34-27.56,19-29.24,19.33a13.8,13.8,0,0,1-4.21-.16l-1,8.71-.67,5.86c-11.67-.57-17.11-7.51-19.28-11.52.15-.86.34-1.79.55-2.78h0l.12-.52c.92-4.31,2.24-9.25,3.66-10.84a35.2,35.2,0,0,1,6.39-5.38l-4.38-10.42s32.44-20.84,33.79-20.5c1,.24,8,14.19,11.82,22.41A41.18,41.18,0,0,1,254.38,176.18Z",
    fill: "#cc8273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.38,176.18c0,1.34-27.56,19-29.24,19.33a13.8,13.8,0,0,1-4.21-.16l-1,8.71-.67,5.86c-11.67-.57-17.11-7.51-19.28-11.52.15-.86.34-1.79.55-2.78h0l.12-.52c4.67,2.7,11.92,2.7,11.92,2.7l1.31-11.33a12.55,12.55,0,0,0,10,1.46c4.08-1,18.76-11,28-17.56A41.18,41.18,0,0,1,254.38,176.18Z",
    fill: "#bd6a5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.11,163.9c.38-.13,9.49,17.18,9.49,17.18",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.78,
    y1: 157.87,
    x2: 238.11,
    y2: 174.8,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.62,158.48l.49.16.14.06c-.06,0-.06,0,0,0l.31.14.17.07h0l.22.1.48.26c.15.09.3.18.44.28s.15.13.22.17-.11-.1,0,0l.1.08.4.37a1.64,1.64,0,0,0,.32.27l.22.09-.08,0a1.36,1.36,0,0,0,.28.11.85.85,0,0,0,1-1c-.1-.55-.63-.88-1.07-1.17a7.12,7.12,0,0,0-1-.55,6.36,6.36,0,0,0-1.2-.43,6.74,6.74,0,0,0-1.27-.11.6.6,0,0,0-.16,1.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.8,163.5c2.23,2.94,2.62,7.28,3.36,10.79.85,4.05,2.5,7.6,4.12,11.38,1.71,4,2,8.4,3.82,12.35.85,1.82,1.89,3.53,2.76,5.34a16.51,16.51,0,0,1,1,2.61c.28,1,.28,2,.52,3a1.12,1.12,0,0,0,2.15,0c.45-1.89-.35-4.05-1.09-5.78s-1.8-3.56-2.76-5.31c-2.19-4-2.74-8.51-4.51-12.67-.93-2.17-2-4.27-2.85-6.49a38.52,38.52,0,0,1-1.53-5.69,27.45,27.45,0,0,0-1.5-5.28,12.6,12.6,0,0,0-3.27-4.44c-.11-.11-.33,0-.22.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.11,208.84c.39-1,.88-1.88,1.25-2.84.18-.47.35-.93.53-1.39s.59-1.15.27-1.75a.7.7,0,0,0-.78-.32c-.67.22-.82.94-1,1.54s-.34,1-.49,1.45a21.3,21.3,0,0,0-.63,3.06.46.46,0,0,0,.88.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.55,196.61a66,66,0,0,0,5.43-10c.73-1.48,1.41-3,2.22-4.42a17,17,0,0,1,1.31-2,12.18,12.18,0,0,0,1.49-1.83c.26-.55-.18-1.4-.87-1.14-1.38.5-2.38,2.21-3.12,3.41-.93,1.52-1.68,3.15-2.46,4.75a66.36,66.36,0,0,0-4.63,10.93.35.35,0,0,0,.63.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,172.25c-.14-.57-.05-1.09-.16-1.66s-.21-1-.33-1.57c0-.12,0-.24-.07-.37l0-.18s0-.2,0-.09,0-.21,0-.28l0-.43c-.06-.56-.05-.36,0-.24a1.1,1.1,0,0,0,0-.18c0-.12,0-.24,0-.36s0-.18,0-.09c0-.16-.05-.56-.08-.81s0-1-.51-1.09a.76.76,0,0,0-.66.27,2.52,2.52,0,0,0-.24.33,2.85,2.85,0,0,0-.25.33,4.71,4.71,0,0,0-.26,3.5,7.93,7.93,0,0,0,.66,1.82,3,3,0,0,0,.57.81,3.87,3.87,0,0,1,.54.72.56.56,0,0,0,1-.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.14,163.82c3.38-1.57,6.51-3.65,9.75-5.49s6.59-3.53,10-5.14,6.75-3.17,10.19-4.61c1.52-.63,3.29-1.69,5-1.8,2.18-.14,1.93,1.82,2.45,3.28a1.48,1.48,0,0,0,2.9-.39,6.06,6.06,0,0,0-2.07-4.43c-1.5-1.18-3.48-1-5.16-.34-1.91.68-3.72,1.65-5.57,2.48s-3.9,1.75-5.85,2.65c-3.87,1.8-7.7,3.71-11.43,5.8s-7.62,4.3-10.58,7.42a.37.37,0,0,0,.44.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.19,204.78a22.93,22.93,0,0,0-.79,5.29c-.18,1.92-.39,3.83-.6,5.75s-.39,3.69-.62,5.53c-.12.92-.2,1.83-.26,2.76a9.46,9.46,0,0,0-.07,2.76.83.83,0,0,0,1.5.19,8.93,8.93,0,0,0,.7-2.66c.2-1,.35-1.88.47-2.84.23-1.84.45-3.68.62-5.53s.27-3.69.38-5.54a20.23,20.23,0,0,0-.15-5.71.62.62,0,0,0-1.18,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.49,232.64a99,99,0,0,1-2.73,20.07c-.83,3.27-2,6.38-3.14,9.54a30.47,30.47,0,0,1-1.79,4.3,17.13,17.13,0,0,1-1.23,1.94,5.41,5.41,0,0,0-1.21,1.83.55.55,0,0,0,.66.66c1.26-.42,2.08-2.07,2.75-3.14.84-1.36,1.59-2.79,2.33-4.22a51.73,51.73,0,0,0,3.56-9.9,58.68,58.68,0,0,0,2.09-21.08.65.65,0,0,0-1.29,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.67,199.12l1.59-1.38.77-.68.4-.35a1.23,1.23,0,0,0,.25-.26,3.84,3.84,0,0,0,.14-.36.59.59,0,0,0-.72-.72,1.4,1.4,0,0,0-.29.09,1.16,1.16,0,0,0-.34.24l-.39.38-.76.72-1.52,1.45a.62.62,0,0,0,.87.87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.59,191.48a65.5,65.5,0,0,1,8.4-6.11,28.93,28.93,0,0,1,9.51-3.82c.89-.18,3.61-.07,3.28-1.64s-2.93-.77-3.9-.61a25.51,25.51,0,0,0-9.36,3.83,44.22,44.22,0,0,0-8.54,7.74.43.43,0,0,0,.61.61Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "f393af66-22b7-4570-8133-64095a7d374d",
    "data-name": "LEFT LEG"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.34,480.62s-3.9,5.46-10.14,7.22-26.15-7.61-38.83-11.7-13.06-6.25-11.31-16.79c.8-4.83,3.13-14.5,5.4-23.55,2.7-10.7,5.33-20.54,5.33-20.54L220.35,419s-2.65,9.52-4.12,16.47c-.33,1.49-.59,2.87-.76,4-1,6.43-1.76,14.63,5.27,23S244.34,480.62,244.34,480.62Z",
    fill: "#b25e4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.35,419s-2.65,9.52-4.12,16.47l-26.77.36c2.7-10.7,5.33-20.54,5.33-20.54Z",
    fill: "#a34a3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.11,503.62h-43.7a13.22,13.22,0,0,1-11.35-6.46c-6.21-10.55-13.81-15.3-13.81-15.3-2.9,6-4.39,16.41-5,21.76H174.15c0-35.77,10-52.86,10-52.86,4.59,6.43,12.48,13.48,20.37,19,7.53,5.32,15.07,9.29,19.78,10.1,9.66,1.65,14.65-4.54,14.65-4.54s18.86,8.46,21.88,12.38S265.11,503.62,265.11,503.62Z",
    fill: "#f77f00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.4,502.17a13.12,13.12,0,0,1-5.34-5c-6.21-10.55-13.81-15.3-13.81-15.3-2.9,6-4.39,16.41-5,21.76H174.15c0-35.77,10-52.86,10-52.86,4.59,6.43,12.48,13.48,20.37,19A145.89,145.89,0,0,0,215.4,502.17Z",
    fill: "#b85f00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253,339.49a2.17,2.17,0,0,1,0,.41c-.29,2.16-2.54,8.34-5.64,16.2-8.21,20.73-22.39,53-22.39,53l-32.34-5,8.89-44.41s-21.32-18.84-37-30.57-33.4-36.95-12.08-59.33c7.11-7.47,21-5.69,36.25,6,3.24,2.49,8,6.53,13.49,11.41,11.85,10.53,27.11,24.94,37.8,36C247.62,331.34,253,337.62,253,339.49Z",
    fill: "#005d8f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.91,339.9c-.29,2.16-2.54,8.34-5.64,16.2-8.21,20.73-22.39,53-22.39,53l-32.34-5,8.89-44.41s-21.32-18.84-37-30.57-33.4-36.95-12.08-59.33c7.11-7.47,21-5.69,36.25,6,3.24,2.49,8,6.53,13.49,11.41-4.45,13.46-14.42,34.34-14.42,34.34S204,319.51,208.43,320s-7.92,13.49-7.92,13.49,14.19,16,27.32,16.07C234.67,349.59,244.78,344.65,252.91,339.9Z",
    fill: "#003049"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.45,323.86s7.1-14.93,19.9-25.23",
    fill: "none",
    stroke: "#0b1823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.63,321.63a45.06,45.06,0,0,1,17.17-14",
    fill: "none",
    stroke: "#0b1823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "184.09 318.97 217.71 348.72 208.28 398.06",
    fill: "none",
    stroke: "#0b1823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M206.57,356.06s11.29-9,20-13",
    fill: "none",
    stroke: "#0b1823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.19,354.68s7.48-3.05,11-3.66",
    fill: "none",
    stroke: "#0b1823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253,339.49a2.17,2.17,0,0,1,0,.41c-.29,2.16-2.54,8.34-5.64,16.2a27.05,27.05,0,0,1-6.42-4.65,19.26,19.26,0,0,1-3.14-4.07,16,16,0,0,1-2-6.27,29,29,0,0,1,.11-7,28.58,28.58,0,0,1,.68-3.25,25.67,25.67,0,0,1,3.44-7.5C247.62,331.34,253,337.62,253,339.49Z",
    fill: "#0085cc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,339.9c-.29,2.16-2.54,8.34-5.64,16.2a27.05,27.05,0,0,1-6.42-4.65,19.26,19.26,0,0,1-3.14-4.07A101.47,101.47,0,0,0,252.91,339.9Z",
    fill: "#003049",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 232.96,
    y1: 330.28,
    x2: 239.67,
    y2: 331.34,
    fill: "none",
    stroke: "#0b1823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 232.8,
    y1: 334.09,
    x2: 238.75,
    y2: 334.09,
    fill: "none",
    stroke: "#0b1823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 242.72,
    y1: 349.04,
    x2: 238.6,
    y2: 354.38,
    fill: "none",
    stroke: "#0b1823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "189.69 396.75 232.09 401.13 225.26 428.29 184.96 422.68 189.69 396.75",
    fill: "#005d8f"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 205.63,
    y1: 401.65,
    x2: 202.65,
    y2: 421.98,
    fill: "none",
    stroke: "#0b1823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 210.36,
    y1: 403.06,
    x2: 208.44,
    y2: 419.18,
    fill: "none",
    stroke: "#0b1823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63,427a10.63,10.63,0,0,0-1,3.78c-.29,1.37-.53,2.75-.8,4.12-.53,2.75-1.09,5.49-1.66,8.23s-1.13,5.32-1.73,8c-.3,1.36-.62,2.73-.93,4.09-.27,1.19-.65,2.41-.09,3.55a.68.68,0,0,0,.93.25,4.72,4.72,0,0,0,1.47-2.91c.32-1.36.63-2.72.94-4.09q1-4.21,1.84-8.44t1.63-8.24c.26-1.38.52-2.75.74-4.14a10.21,10.21,0,0,0,.32-3.95.9.9,0,0,0-1.62-.22Z",
    fill: "#ddb987"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.65,467.88c0,.07,0,.13,0,.2a.63.63,0,0,1,0,.19c0-.12,0-.14,0-.08v.08l0,.16a4.55,4.55,0,0,1-.19.7c-.07.22-.13.45-.2.68a4.27,4.27,0,0,0-.19.93l0-.26c0,.1,0,.21,0,.31a.91.91,0,0,0,.21.6,1,1,0,0,0,.76.4,1.11,1.11,0,0,0,.72-.29,3,3,0,0,0,.26-.36,3.41,3.41,0,0,0,.37-1.37,5,5,0,0,0,0-.95,8.62,8.62,0,0,0-.2-1.13.73.73,0,0,0-.8-.52.74.74,0,0,0-.63.71Z",
    fill: "#ddb987"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.61,477.8a58.9,58.9,0,0,0-.57,6.09c0,2-.1,3.91-.13,5.87,0,4-.12,8-.24,11.95,0,1.9,3,1.91,3,0q0-6,0-11.95c0-2,0-3.91,0-5.87s-.23-4-.43-6.09a.83.83,0,0,0-1.65,0Z",
    fill: "#ddb987"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M219.73,296.08c1.51,1.33,2.81,2.84,4.38,4.11s3.06,2.41,4.56,3.66c3.11,2.6,6.09,5.34,9,8.11s5.55,5.7,8.18,8.67c1.34,1.52,2.65,3.06,4,4.61a38.82,38.82,0,0,0,3.75,4.33,13.84,13.84,0,0,1,2.19,3,22.27,22.27,0,0,1,1.54,2.84,11.69,11.69,0,0,1,1,3.51,14.42,14.42,0,0,1-.4,3.32c-.14,1,1.23,1.84,1.82.76,1.89-3.38-.47-8-2.37-10.87-.59-.9-1.25-1.75-1.89-2.61s-1-1.88-1.66-2.77c-1.2-1.65-2.44-3.29-3.73-4.88a140.57,140.57,0,0,0-18-18.38c-1.82-1.54-3.68-3-5.56-4.5a46.63,46.63,0,0,0-6.2-3.68c-.45-.25-1,.37-.56.73Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M257,346.39a6.73,6.73,0,0,0-.32.73c-.06.2-.12.41-.17.61-.08.39-.18.78-.29,1.16s-.24.77-.39,1.14l-.12.32c-.1.25.1-.21,0,0a5,5,0,0,0-.23.53,3.6,3.6,0,0,0-.08.56,1.2,1.2,0,0,0,.72,1.08,1.17,1.17,0,0,0,1.28-.25,3.9,3.9,0,0,0,.8-1.52,11.42,11.42,0,0,0,.36-1.23c.1-.42.18-.84.24-1.27a5.56,5.56,0,0,0,.05-.82,4.15,4.15,0,0,0-.16-.84.92.92,0,0,0-1.68-.22Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M254.19,355.18c-1.94,4.22-3.49,8.58-5.12,12.94-1.55,4.13-2.78,8.62-5.29,12.3a1,1,0,0,0,0,1,1.1,1.1,0,0,0,.61.47,1.06,1.06,0,0,0,1.17-.47c2.16-3.78,3.45-8.11,4.95-12.17,1.68-4.53,3.45-9,4.79-13.65.18-.64-.81-1.1-1.11-.46Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.93,326c5.95,6.09,6.67,15.2,5.05,23.14a132,132,0,0,1-3.8,13.32c-1.48,4.7-3.45,9.48-4.24,14.36-.09.54.68,1,1,.41,2.3-4.63,3.51-9.89,5.1-14.79a98.5,98.5,0,0,0,4-14.69c1.26-8,.19-17.08-6.62-22.34-.35-.27-.74.29-.46.59Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M251.8,381.53c-.17.81-.4,1.63-.64,2.43-.12.4-.24.81-.38,1.21-.07.2-.15.39-.22.6a3.76,3.76,0,0,0-.1.76.83.83,0,0,0,1.41.58,2.48,2.48,0,0,0,.49-.72,6,6,0,0,0,.25-.71,10.63,10.63,0,0,0,.33-1.23,12.6,12.6,0,0,0,.2-2.74.69.69,0,0,0-.59-.67.67.67,0,0,0-.75.49Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e10ef64a-69b6-4d07-a86b-ad51bca20b84",
    "data-name": "RIGHT LEG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.49,480.62s-3.9,5.46-10.14,7.22c-5.48,1.54-21.51-5.5-33.92-10-1.72-.63-3.36-1.21-4.9-1.7-12.69-4.1-16.13-6.38-14.37-16.91.2-1.2-24.15-24-31.94-32l33.13-1.94S284.57,431,292.09,438c9.43,8.81,20.9,19.78,24.8,24.43C323.91,470.86,340.49,480.62,340.49,480.62Z",
    fill: "#cc8273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.43,477.84c-1.72-.63-3.36-1.21-4.9-1.7-12.69-4.1-16.13-6.38-14.37-16.91.2-1.2-24.15-24-31.94-32l33.13-1.94S284.57,431,292.09,438C291.3,444.21,290.85,457.44,296.43,477.84Z",
    fill: "#bd6a5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.27,503.62H317.56c-.33,0-.65,0-1,0a13.17,13.17,0,0,1-10.38-6.42c-6.21-10.55-13.81-15.3-13.81-15.3-2.9,6-4.38,16.41-5,21.76H270.3c0-24.17.95-39.35,1.57-46.66a2.23,2.23,0,0,1,3.78-1.41c5.11,5.11,12.88,10.22,20.69,14.44,9.65,5.22,19.36,9.08,24.17,9.91,9.66,1.65,14.64-4.54,14.64-4.54S354,483.82,357,487.74,361.27,503.62,361.27,503.62Z",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.59,503.58a13.17,13.17,0,0,1-10.38-6.42c-6.21-10.55-13.81-15.3-13.81-15.3-2.9,6-4.38,16.41-5,21.76H270.3c0-24.17.95-39.35,1.57-46.66a2.23,2.23,0,0,1,3.78-1.41c5.11,5.11,12.88,10.22,20.69,14.44A109.69,109.69,0,0,0,316.59,503.58Z",
    fill: "#b85f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.07,420.85l-5,6.06-14.67,17.93s-148.88-83.3-156.57-92.4-12.8-35.59-10-61.78,49.81-26.47,56.93-12.52,15.61,44.42,15.61,44.42l42.77,37L235.51,384Z",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.51,384c-19.7,9.92-36.73-11.41-28.3-24.48Z",
    fill: "#0085cc"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.65,
    y1: 365.14,
    x2: 207.41,
    y2: 365.14,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.29,
    y1: 368.4,
    x2: 207.41,
    y2: 367.88,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.89,
    y1: 384.02,
    x2: 223.89,
    y2: 389.08,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.1,426.91l-14.67,17.93s-148.88-83.3-156.57-92.4-12.8-35.59-10-61.78,49.81-26.47,56.93-12.52,15.61,44.42,15.61,44.42-29,5.16-40.09,13.4,24-3.46,24.87-3.73c-.43.4-11.15,10.34-12,18.8-.82,8.61,46.81,38.22,85.94,57.53C239.32,416.51,257.4,422.56,273.1,426.91Z",
    fill: "#003049"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "163.96 291.13 168.72 314.62 164.44 322.56 155.79 294.03",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39,323.34s-21.66,0-36.48,8.76,32.38-6.45,32.38-6.45",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.26,328.61s-14.76,5.55-23,19.28",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.41,430.54,122.17,349.17s-7.87-9.6-10-29.16",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.77,317.84s3.88,17.38,3.88,19.4-5.48,11.93-5.48,11.93",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.06,
    y1: 397.81,
    x2: 206.12,
    y2: 387.38,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.4,
    y1: 399.55,
    x2: 206.12,
    y2: 395.2,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.83 430.34 288.92 434.53 267.86 457.14 250.78 444.72 250.69 444.66 277.23 414.21 292.83 430.34",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.92,434.53l-21.06,22.61-17.08-12.42,12.19-12S275.54,437.5,288.92,434.53Z",
    fill: "#003049"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.96,
    y1: 433.99,
    x2: 277.23,
    y2: 444.39,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.43,
    y1: 432.68,
    x2: 277.49,
    y2: 439.19,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.07,389.25c1.44,2.18,3.91,3.75,5.9,5.41q3.33,2.76,6.73,5.42c2.13,1.68,4.24,3.44,6.46,5,1.13.79,2.33,1.46,3.45,2.27a24.48,24.48,0,0,0,3.64,2.42.49.49,0,0,0,.59-.77,22.43,22.43,0,0,0-3-2.81c-1.05-.9-2-1.89-3-2.81-2.12-1.91-4.48-3.6-6.72-5.36s-4.32-3.36-6.53-5-4.32-3.68-6.85-4.58a.54.54,0,0,0-.61.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.86,414.22l.16.29-.1-.38a.88.88,0,0,0,.23.6l.15.18c.1.12.19.25.3.36a6.25,6.25,0,0,0,.69.56c.28.23.56.47.85.69a4.73,4.73,0,0,0,.39.28,1.22,1.22,0,0,0,1,.17,1,1,0,0,0,.69-.91,1.3,1.3,0,0,0-.6-1.06l-.39-.28c-.24-.17-.49-.32-.74-.48s-.49-.34-.75-.48a6.14,6.14,0,0,0-.59-.25,1.12,1.12,0,0,0-.72-.09h.4l-.34-.06a.59.59,0,0,0-.66.86Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,425.36a3.77,3.77,0,0,1,1.38.94l1.34,1.16c.92.76,1.84,1.52,2.75,2.29,1.83,1.53,3.62,3.12,5.35,4.78,1,1,2.6-.6,1.56-1.56q-2.86-2.64-5.95-5c-1-.77-2-1.48-3.11-2.17-.53-.34-1.09-.64-1.63-.95a3.5,3.5,0,0,0-1.55-.56c-.61-.05-.72.9-.14,1.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,441.77A170.36,170.36,0,0,0,324.51,457c2.48,2.41,5,4.78,7.6,7.06a33.9,33.9,0,0,0,4,3c1.48.95,2.69,2.53,4.28,3.25.46.22,1.13-.26.78-.77-.92-1.33-2.46-2.12-3.56-3.3s-2.3-2.58-3.57-3.75c-2.59-2.4-5.26-4.73-7.86-7.13-5.15-4.74-10-9.83-15.12-14.56a.73.73,0,0,0-1,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,475c2.71,2.9,6.22,4.12,9.7,5.79a19.74,19.74,0,0,1,4.37,2.72,12.35,12.35,0,0,1,3,4.12c.62,1.23,2.26.31,2.06-.87a8.84,8.84,0,0,0-2.89-4.64,18,18,0,0,0-4.59-3c-3.57-1.72-7.64-2.69-10.89-5-.56-.4-1.16.46-.72.93Z",
    fill: "#ddb987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,491.14c0,.88-.1,1.74-.06,2.61s.13,1.85.27,2.79c.25,1.66.51,3.44.68,5a1.72,1.72,0,1,0,3.38-.46c-.44-1.7-.83-3.42-1.21-5.14a21.16,21.16,0,0,0-.67-2.45c-.3-.88-.73-1.68-1-2.56-.24-.7-1.39-.63-1.36.18Z",
    fill: "#ddb987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.86,419.05c6,6.06,12.34,11.81,18.68,17.54,2.92,2.65,5.84,5.3,8.84,7.87a54.74,54.74,0,0,0,9.39,7c.9.48,2-.78,1.15-1.49-3-2.45-6.13-4.74-9.07-7.27s-5.91-5.23-8.87-7.85c-6.36-5.62-12.73-11.23-19.37-16.51-.52-.41-1.24.25-.75.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.18,458c.25.4.52.79.8,1.18s.57.85.89,1.25a18.16,18.16,0,0,0,2,2.06c.56.5,1.25,1.22,2.06.75a1.09,1.09,0,0,0,.53-.94,1.23,1.23,0,0,0-.37-.84.69.69,0,0,0-.13-.11c-.05,0-.45-.34-.2-.16-.75-.55-1.45-1.19-2.15-1.8l-.6-.54a1.5,1.5,0,0,0-.25-.19s-.15-.11-.06,0c-.11-.09-.21-.19-.31-.29-.38-.37-.76-.75-1.12-1.14a.67.67,0,0,0-1.05.81Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.73,398.7c3.67,1.85,7.5,3.31,11.2,5.08.95.45,1.7.91,1.76,2.06a11.91,11.91,0,0,1-.52,3.23c-.28,1.25-.55,2.52-.81,3.78-.24,1.1-.94,2.71-.25,3.73a1,1,0,0,0,1.29.34c1.17-.75,1.15-2.69,1.4-3.95s.54-2.76.79-4.15c.42-2.26.7-4.84-1.51-6.28a24.28,24.28,0,0,0-6.42-2.42c-2.23-.64-4.51-1.16-6.68-2-.34-.13-.56.42-.25.58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.15,363.58c2.87,3.27,7.25,5,11.11,6.76,2,.92,4,1.85,5.91,2.94a56.3,56.3,0,0,1,6.07,4.23A99.13,99.13,0,0,0,138,385.19c4.19,2.28,8.33,4.67,12.58,6.84,1.37.7,2.77,1.36,4.17,2a9.69,9.69,0,0,1,3.37,2c1,1.17,2.56-.49,1.65-1.65a9.4,9.4,0,0,0-2.78-2c-1.3-.75-2.57-1.51-3.9-2.2-3.73-2-7.44-4-11.15-6-4.46-2.4-9.16-4.59-13.32-7.5-2.09-1.46-4.05-3.09-6.2-4.46a39.4,39.4,0,0,0-5.82-3c-2.32-1-4.69-1.85-7-2.87s-4.63-2.31-6.9-3.58a.45.45,0,0,0-.54.7Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "b316639e-4955-41e1-bc7a-b8a94e76928b",
    "data-name": "BODY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.48,243.48s-30.94-14.16-44-32.17-17.7-27.71-17.7-27.71l2.42-1,18.76-7.4,21.48-4.14.89-.17s13.46,16.26,16.93,33.93S149.48,243.48,149.48,243.48Z",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.48,243.48s-30.94-14.16-44-32.17-17.7-27.71-17.7-27.71l2.42-1c17.05,24.33,55.48,52.22,55.48,52.22-2.21-29-12.81-57.55-15.24-63.76l.89-.17s13.46,16.26,16.93,33.93S149.48,243.48,149.48,243.48Z",
    fill: "#003049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.44,184.72s13.93,21.86,20.39,43.27",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.74,176.42a16.29,16.29,0,0,1-2.57,4.78A18.78,18.78,0,0,0,115.5,177a58.15,58.15,0,0,0-.39,6.33c-8.4.34-12.33-3.19-12.33-3.19l.26-6.91a28.66,28.66,0,0,1,17.2-3.11Z",
    fill: "#bb233d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.09,171.32a10,10,0,0,1-1.56,2.42,9.11,9.11,0,0,1-5.61-1l-2-13.39.63.14,6.72,1.59,1.51,8.61Z",
    fill: "#cc8273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.79,169.65c-7-.34-8.05-7.65-8.23-10.2l6.72,1.59Z",
    fill: "#1b2d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.75,280.55s-5,17-16.13,31.22L159.79,295l-6.38,18.06L148,328.43A121.2,121.2,0,0,1,81.83,313l.25-41.48L50,228.71a91.88,91.88,0,0,1,3.41-13.4,68.42,68.42,0,0,1,8.2-17.06,34.7,34.7,0,0,1,8.34-8.69l17.89-6s38.88,50.55,61.69,59.88c0,0,5.57-29.42-18.65-72.32l16.84-8L153.12,181s20,19.43,20.75,25.13c.32,2.39-.73,8.84-2,15.52l0,.16c-1.67,8.5-3.8,17.33-4.12,18.64l0,.16Z",
    fill: "#d62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.82,221.67l0,.16-4.12,18.64,0,.16s-33.09,16.42-42.72,34.18c-8.63,15.89,12.33,29.82,28.5,38.24L148,328.43A121.2,121.2,0,0,1,81.83,313l.25-41.48L49.94,228.7a92.25,92.25,0,0,1,3.42-13.38c18.4,9.62,42.71,28.86,58.76,33.57C132.1,254.75,159.62,244.71,171.82,221.67Z",
    fill: "#902429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.08,271.48,50,228.71a91.88,91.88,0,0,1,3.41-13.4,68.42,68.42,0,0,1,8.2-17.06C68.29,203.39,74.14,213,74.14,213S96.33,233.59,82.08,271.48Z",
    fill: "#6d1c1f"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "150.7 248.89 151.17 261.23 158.85 287.78",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.07,
    cy: 260.54,
    r: 2.56,
    fill: "#1b2d3d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.39,
    cy: 274.52,
    r: 2.56,
    fill: "#1b2d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.26,249.51s11.39,13.23,15.08,18.59l-.84,30.32",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "86.8 266.26 94.34 268.1 117.62 274.81",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.37,
    y1: 276.48,
    x2: 119.47,
    y2: 283.52,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8,183.56l7.76-2s36.55,48.28,58.28,58.93c.83-4.9-1.59-35.85-19.58-70.35l7.32-3.11s13.31,16,21.3,32.39L153,213.63l8.65,1.77s-2.81,18.91-12.16,28.09c0,0-24,.53-36.42-5.68l5.55-11.31-19.08,1.77S89.13,210.27,82.8,183.56Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.64,166.7a3.62,3.62,0,0,0,.22.63,3.56,3.56,0,0,0,.37.58,2.59,2.59,0,0,0,.37.37l.35.26a1.33,1.33,0,0,0,.44.14.79.79,0,0,0,.58-.08.78.78,0,0,0,.31-.36.75.75,0,0,0,0-.49.79.79,0,0,0-.35-.45l-.19-.12a2.39,2.39,0,0,0-.37-.15l.18.08a2.36,2.36,0,0,1-.48-.29l.14.11a1.85,1.85,0,0,1-.4-.39l.1.13a2,2,0,0,1-.25-.41.59.59,0,0,0-.35-.27.59.59,0,0,0-.37,0,.6.6,0,0,0-.28.24.66.66,0,0,0-.06.44Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.43,166c4.16-1.81,8.3-3.63,12.42-5.54a44.44,44.44,0,0,1,6.22-2.46,17.09,17.09,0,0,1,3.33-.67c1-.09,1.94.12,2.89-.06.77-.15.61-1.18,0-1.41a7.53,7.53,0,0,0-3.34,0,19.91,19.91,0,0,0-2.85.55,36.55,36.55,0,0,0-6.17,2.37c-4.37,2.06-8.62,4.3-12.9,6.52-.47.25-.06.9.4.7Z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "f685e07f-ce78-473f-9d1f-b01f4f018e8f",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,148.77s-5.43,2.93-5.5,8.64-3,21.13-20.42,21.71c-9.63.31-13.44-3.32-14.87-6.9a12.5,12.5,0,0,1-.63-6.67c5.79,4.86,13.29,1.86,16.64-8.64s9.5-16.28,16.36-14.93a11.14,11.14,0,0,1,7.42,4.79A8.26,8.26,0,0,1,103,148.77Z",
    fill: "#1b2d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,148.77s-5.43,2.93-5.5,8.64-3,21.13-20.42,21.71c-9.63.31-13.44-3.32-14.87-6.9,10.29,10.63,24.94,1.55,25.3-8,.38-10,1.41-16,7.08-18.27a8,8,0,0,1,7.41.8A8.26,8.26,0,0,1,103,148.77Z",
    fill: "#13222d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.32,159.4c-.35,3.82-1.84,6-4.77,6.21a11.71,11.71,0,0,1-5.42-1.29c-6.57-2.93-6.34-17.47-.61-19.18a12.12,12.12,0,0,1,1.57-.37C120.06,143.24,120.81,154,120.32,159.4Z",
    fill: "#cc8273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.55,165.61a11.71,11.71,0,0,1-5.42-1.29c-6.57-2.93-6.34-17.47-.61-19.18a12.12,12.12,0,0,1,1.57-.37C109.93,155.29,111,161.68,115.55,165.61Z",
    fill: "#bd6a5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.55,146.26a3.21,3.21,0,0,0-3.34.42c-1.61,1.3-.73,5.89,2.45,4.79S106,146.84,104.55,146.26Z",
    fill: "#bb233d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.68,153.3c-2.31,3.43-8.25,3.36-10.5-.9s-4.89-3.08-4.89-3.08a9.1,9.1,0,0,1,0,3.57,3.28,3.28,0,0,1-2.56,2.79v1.75l-1.88.32s-4.33-5.63-2.54-10.21l.06-.17c2-4.61,7-3.51,7-3.51s4.06-3.49,9.1-1.81c6.73,2.24,4.61,11.12,4.61,11.12Z",
    fill: "#1b2d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.33,152.89a3.28,3.28,0,0,1-2.56,2.79v1.75l-1.88.32s-4.33-5.63-2.54-10.21C104.69,150.85,108.1,152.28,110.33,152.89Z",
    fill: "#13222d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.39,158l.51,2s-.62,2.4-3.88,1.28c-3.54-1.22-4.55-7.23-.37-6.71A4.52,4.52,0,0,1,107.39,158Z",
    fill: "#bd6a5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.37,177.32a8,8,0,0,1-.83-1,4.88,4.88,0,0,1-.43-1.14c-.29-.84-.63-1.66-.84-2.53a14.3,14.3,0,0,1-.36-2.52,14.86,14.86,0,0,0-.14-2.84,1,1,0,0,0-1.83,0,7.51,7.51,0,0,0-.07,3,17.35,17.35,0,0,0,.51,3.05,7.59,7.59,0,0,0,1.21,2.74c.28.35.62.63.9,1a9.19,9.19,0,0,0,1,1.11.59.59,0,0,0,.83-.83Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.79,163.12l.58-1a2.57,2.57,0,0,0,.31-.62,1.37,1.37,0,0,0,0-.35,1.12,1.12,0,0,0,0-.32.29.29,0,0,0-.34-.2,1.43,1.43,0,0,0-.27.15,2.61,2.61,0,0,0-.27.19,1.89,1.89,0,0,0-.33.61l-.51,1.07a.49.49,0,1,0,.85.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.77,160.92a15,15,0,0,0,4.45,2.18,3.83,3.83,0,0,0,3.7-1.54,15.49,15.49,0,0,0,2.34-3.93,16.82,16.82,0,0,0,.79-2.26,5.16,5.16,0,0,0,.32-2.38A.76.76,0,0,0,73,152.8a7.62,7.62,0,0,0-.44,2,16.25,16.25,0,0,1-.57,1.92,15.08,15.08,0,0,1-1.84,3.54c-.71,1-1.62,1.89-2.93,1.56A24.38,24.38,0,0,1,63,160.46c-.31-.14-.58.28-.27.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4,149.8a2.09,2.09,0,0,1,.08-.23,1.21,1.21,0,0,1,0-.14c0-.1,0,0,0,0a1.37,1.37,0,0,0,.13-.2l.07-.09c.1-.14-.11.14,0,0,.24-.31.41-.67.65-1l-.14.19.35-.46-.15.19a2.48,2.48,0,0,0,.5-.78,1.63,1.63,0,0,0,0-.76.67.67,0,0,0-.46-.46,1.52,1.52,0,0,0-.67,0,1.37,1.37,0,0,0-.78.62,5.4,5.4,0,0,0-.48,1,2.79,2.79,0,0,0-.21,1c0,.14,0,.28,0,.42a3.85,3.85,0,0,0,0,.48.53.53,0,0,0,.47.53.55.55,0,0,0,.6-.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,143.65c.68-.53,1.49-.92,2.22-1.4A21.75,21.75,0,0,1,87.33,141a17.79,17.79,0,0,1,4.76-1.59,10.78,10.78,0,0,1,5,.05c1.65.48,2.47,1.86,3.68,2.94,1,.89,2.76-.27,1.94-1.5a9.58,9.58,0,0,0-4.37-3.59c-1.85-.7-4.15-.4-6.06-.06a19.26,19.26,0,0,0-5.51,1.9,17.45,17.45,0,0,0-2.49,1.58,7.23,7.23,0,0,0-1.13.94c-.34.38-.6.86-.93,1.26a.52.52,0,0,0,.74.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,141.67c.57-.18,1.18-.25,1.76-.39s1.16-.37,1.76-.49c.28-.07.56-.09.83-.17l1-.23.83-.18a1.46,1.46,0,0,0,1.07-.69.89.89,0,0,0-.31-1.18c-.64-.45-1.46-.09-2.13.1a13.37,13.37,0,0,0-1.83.67c-.56.26-1.16.45-1.7.75s-1,.72-1.55,1.06a.41.41,0,0,0,.32.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.32,140.59c2.28-.22,4.93,0,6.78,1.48a8.54,8.54,0,0,1,2.89,5.59c.77,5.3-2.08,10-2.85,15.11-.19,1.26,1.59,1.83,2,.54,1.57-5.56,4.23-11.65,2.61-17.49-1.39-5-6.63-8.63-11.63-6.11a.48.48,0,0,0,.24.88Z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "f496c74b-c23c-4205-a435-44aae9e57bac",
    "data-name": "ROPE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.26,192.63c-5.68,11.73-10.62,27.77-12.61,49.51-1.89,20.64-9.84,36.39-23.63,46.81-22.43,16.95-53.1,14.26-62,13L95.68,322.11V472a5.19,5.19,0,0,1-5.16,5.15A5.16,5.16,0,0,1,85.37,472V319.68a5.14,5.14,0,0,1,1.87-4l28-23.15a5.09,5.09,0,0,1,4.23-1.09c.34,0,34.11,6.07,56.36-10.78,11.35-8.6,17.92-21.89,19.54-39.49,2.17-23.78,7.67-41.38,14.08-54.29.76-1.55,1.55-3,2.34-4.45A42,42,0,0,0,218.26,192.63Z",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.26,192.63c-5.68,11.73-10.62,27.77-12.61,49.51-1.89,20.64-9.84,36.39-23.63,46.81-22.43,16.95-53.1,14.26-62,13L95.68,322.11V472a5.1,5.1,0,0,1-1.56,3.67l-3-138.37-5.74-2.7v-9.31L93,317.56l20.28-19.14s29,1.33,48.13-2.8,38.81-24.54,39.51-51.49,12.46-49.49,12.46-49.49a47.57,47.57,0,0,1-3.88-7.72c.76-1.55,1.55-3,2.34-4.45A42,42,0,0,0,218.26,192.63Z",
    fill: "#b85f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.06,336a38.27,38.27,0,0,0-.41,8.22c0,2.93.12,5.87.19,8.81s.1,5.73.2,8.59,0,5.87.94,8.56c.22.61,1.25.76,1.4,0,.54-2.72.17-5.57.09-8.32-.09-2.94-.18-5.89-.28-8.83s-.17-5.71-.27-8.57a39.38,39.38,0,0,0-.86-8.46.52.52,0,0,0-1,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.21,376.63a10.92,10.92,0,0,1-.12,1.15c-.07.39-.11.8-.17,1.2s-.09.88-.13,1.32a2,2,0,0,0,.22,1.45.77.77,0,0,0,1.3,0,2,2,0,0,0,.22-1.41c0-.45-.07-.91-.13-1.36s-.1-.77-.17-1.16a11.69,11.69,0,0,1-.12-1.19.45.45,0,0,0-.9,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.71,387.75c0,4.13,0,8.22.34,12.33s.82,8.09,1.37,12.12c.2,1.5,2.51.88,2.29-.63q-.88-6-1.52-12c-.42-4-1-7.9-1.48-11.86-.08-.62-1-.66-1,0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "aaa4872a-6331-47a6-bbe1-8e1703cd5403",
    "data-name": "RIGHT ARM"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M137.26,312.85s-8,10.29-16.47,19.9c-1.62,1.84-3.26,3.65-4.87,5.37l-15.15-11.51S91.09,331.1,87.43,331s-10.66-11.65-10.66-11.65l-5.9-3.65L83.08,297l7.07,3.52,1.31.65s17.66-13.83,20.31-15.11S136.14,310.33,137.26,312.85Z",
    fill: "#cc8273"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.79,332.75c-1.62,1.84-3.26,3.65-4.87,5.37l-15.15-11.51S91.09,331.1,87.43,331s-10.66-11.65-10.66-11.65l-5.9-3.65L83.08,297l7.07,3.52-4.78,17.32s3,4.66,4.39,5.51,10.3-3.33,10.3-3.33Z",
    fill: "#bd6a5c"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M112.55,289.59s-3.51-.29-1.42,7.49c0,0-8.64-4.27-6.64,10,0,0-8.83-3.41-5.6,8.73",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 107.08,
    y1: 313.42,
    x2: 122.95,
    y2: 326.89,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 116.21,
    y1: 304.57,
    x2: 129.82,
    y2: 318.05,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.87,297.05l-7.34,12.79-9.07,15.81s-25.79-12.53-44.81-24.72c-10.56-6.78-19-13.45-19.84-17.8-.44-2.38.42-6.19,2.18-10.88,1.14-3.1,2.69-6.57,4.49-10.29C22,242.44,39,216.54,46.34,206.79c10.95-14.43,23.56-17.23,23.56-17.23,17.59,14.36,16,44.09,16,44.09L74.15,251.39,56.78,277.65Z",
    fill: "#d62828"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.53,309.84l-9.07,15.81s-25.79-12.53-44.81-24.72c-10.56-6.78-19-13.45-19.84-17.8-.44-2.38.42-6.19,2.18-10.88C20.05,284.25,58.19,301,79.53,309.84Z",
    fill: "#ac2020"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.15,251.39,56.78,277.65,42.27,284.9l5.32-6.4s-24.62,2.41-20.74-.19C29.69,276.41,57.18,263.13,74.15,251.39Z",
    fill: "#902429"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M66.24,199.31s17.17,10,19.63,34.34",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M67,210s10.34,5.73,15.59,19.4",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.13,286.47a30.68,30.68,0,0,1-3.48,14.46c-10.56-6.78-19-13.45-19.84-17.8-.44-2.38.42-6.19,2.18-10.88,1.14-3.1,2.69-6.57,4.49-10.29C17.38,264.81,28.79,272.88,29.13,286.47Z",
    fill: "#e36464"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.13,286.47a30.68,30.68,0,0,1-3.48,14.46c-10.56-6.78-19-13.45-19.84-17.8-.44-2.38.42-6.19,2.18-10.88C12.33,276.56,20,281.49,29.13,286.47Z",
    fill: "#ac2020",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 17.35,
    y1: 268.03,
    x2: 20.98,
    y2: 264.41,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 19.59,
    y1: 269.76,
    x2: 22.7,
    y2: 267.17,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 26.85,
    y1: 293.78,
    x2: 31.86,
    y2: 295.17,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9,281.34c.52-.34,22-4.15,22-4.15",
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 39.64,
    y1: 286.01,
    x2: 52.43,
    y2: 280.65,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.53,
    cy: 305.53,
    r: 2.94,
    fill: "#1b2d3d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.31,
    cy: 311.04,
    r: 2.94,
    fill: "#1b2d3d"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 79.1,
    y1: 295.62,
    x2: 66.41,
    y2: 317.99,
    fill: "none",
    stroke: "#1b2d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13,298.32c4.33,2.67,8.51,5.59,12.79,8.34s8.76,5.18,13.19,7.66a135.91,135.91,0,0,0,13,6.82,46.67,46.67,0,0,0,6.52,2.09c1.16.29,2.32.58,3.47.93a18.38,18.38,0,0,0,3.23.95.93.93,0,0,0,.65-1.57c-1.64-1.4-4.3-1.76-6.34-2.27a47.37,47.37,0,0,1-6.53-2,128.21,128.21,0,0,1-13.15-6.86c-4.38-2.41-8.71-4.94-13.16-7.21s-9.14-4.53-13.55-7.05a.1.1,0,0,0-.1.17Z",
    fill: "#ddb987"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M66.05,329.78c1.51.68,3,1.38,4.48,2.09.73.35,1.46.68,2.21,1a7.52,7.52,0,0,0,2.34.66c.77,0,1.15-1.16.41-1.5a20.13,20.13,0,0,0-2.32-.72c-.72-.23-1.45-.48-2.17-.73-1.54-.52-3.06-1.07-4.58-1.63-.5-.19-.86.65-.37.87Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.72,202.36c2-2.36,4.17-4.62,6.39-6.8,1.1-1.07,2.21-2.13,3.35-3.17s2.55-2,3.27-3.33c.29-.52-.19-1.34-.84-1.09a4.25,4.25,0,0,0-1.06.49,11.32,11.32,0,0,0-.91.8c-.57.51-1.15,1-1.71,1.54q-1.76,1.59-3.45,3.24A91.54,91.54,0,0,0,43.31,201c-.82,1,.57,2.38,1.41,1.41Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,250.87c4.07-6.86,8.5-13.56,13-20.17,4.57-6.78,9.08-13.61,13.79-20.3.71-1-1-2-1.66-1-4.66,6.7-9.13,13.56-13.6,20.4-2.14,3.28-4.26,6.57-6.26,9.94a101.54,101.54,0,0,0-5.48,10.94c-.08.17.16.33.26.15Z",
    fill: "#ddb987"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M62.39,187.26c.43-.1.84-.24,1.26-.38a5.32,5.32,0,0,0,1.34-.69,1.21,1.21,0,0,0,.4-.47.89.89,0,0,0,0-.64,1.11,1.11,0,0,0-.44-.58,1,1,0,0,0-1,0c-.3.22-.58.47-.87.69l.18-.14-.71.58.16-.13a8.13,8.13,0,0,1-.87.57.65.65,0,0,0-.26.82.64.64,0,0,0,.76.37Z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52,257.09A33.16,33.16,0,0,0,1.67,268.5a41.89,41.89,0,0,0-1.29,6.26,20.42,20.42,0,0,0-.17,6.57c.24,1.16,1.82.76,1.92-.26.21-1.95,0-3.95.18-5.92A32.8,32.8,0,0,1,3.54,269a42.59,42.59,0,0,1,5.2-11c.47-.73-.66-1.64-1.22-.94Z",
    fill: "#ddb987"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M.82,287.55l.36.84c.08.18,0-.14,0,0a2,2,0,0,0,.15.41c.06.13.12.26.17.39.25.54.49,1.09.73,1.64a1.13,1.13,0,0,0,1.95,0,1.13,1.13,0,0,0,0-1.14c-.34-.49-.66-1-1-1.49L3,287.88l-.18-.24-.09-.09.06.08-.07-.11-.51-.75a.79.79,0,0,0-1.06-.28.78.78,0,0,0-.36.46.89.89,0,0,0,.08.6Z",
    fill: "#ddb987"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "bc9413b8-99db-43ba-9fe2-72ee60b0cbb5",
    "data-name": "DOTS"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 429.57,
    cy: 204.02,
    r: 6.61,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.18,
    cy: 379.15,
    r: 2.49,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.35,
    cy: 418.67,
    r: 5.09,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.45,
    cy: 168.76,
    r: 3.28,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.42,
    cy: 60.19,
    r: 5.4,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.14,
    cy: 100,
    r: 1.77,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.24,
    cy: 339.72,
    r: 2.41,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.71,
    cy: 407.26,
    r: 5.2,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.84,
    cy: 284.92,
    r: 3.2,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.74,
    cy: 246.92,
    r: 3.15,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.32
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanIdea);
export default __webpack_public_path__ + "static/media/woman_idea.e8b618d4.svg";
export { ForwardRef as ReactComponent };